import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SigninWidget.scss";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Home from "../../pages/Home/Home";
import Login from "./Login";
import Dashboard from "../../pages/Dashboard/Dashboard";

const SigninWidget = () => {


  return (
    <>
  
    <AuthenticatedTemplate>
      <Dashboard/>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
        <Login/>
    </UnauthenticatedTemplate>

    </>
  );
};

export default SigninWidget;